import { useState } from 'react';

import { FormFieldSet } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';
import { useFormContext } from 'react-hook-form';

import { useDriversListSelectedQuery } from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelectContextField } from 'src/common/FormField/MultiSelectContextField';
import { CoreFormFieldSwitch } from 'src/common/FormField/v2/core/CoreFormFieldSwitch';

export const PayerAuthorizedDriverSettings = () => {
  const { watch } = useFormContext();
  const requiresDriverAuthorization = watch('allow_only_specific_drivers');
  const allowedDrivers = watch('allowed_drivers');

  const [query, setQuery] = useState('');

  const {
    data: drivers,
    isLoading,
    isFetching,
  } = useDriversListSelectedQuery({
    search: query,
    driverFilters: {
      selected_drivers: allowedDrivers,
    },
    pageSize: 1000,
  });

  const driverOptions = drivers?.results.map((d) => ({
    label: `${d.first_name} ${d.last_name}`,
    value: d.id,
  }));

  return (
    <div className="py-2">
      <FormFieldSet
        legend="Allowed Drivers"
        Fields={
          <>
            <FormFieldController name="allow_only_specific_drivers">
              {({ field }) => {
                return (
                  <CoreFormFieldSwitch
                    colSpan={12}
                    label="Allow only specific drivers"
                    inputProps={{
                      value: field.value,
                      onChange: field.onChange,
                      id: 'allow_only_specific_drivers',
                    }}
                    helperText={{
                      text:
                        'Enabling this option means that only drivers explicitly selected below ' +
                        'will be able to complete trips for this payer.',
                      presentation: {
                        type: 'tooltip',
                      },
                    }}
                  />
                );
              }}
            </FormFieldController>
            <div className="col-span-12">
              <MultiSelectContextField
                options={driverOptions || []}
                fieldPath="allowed_drivers"
                label="Allowed Drivers"
                placeholder="Select Drivers"
                disabled={
                  isLoading || isFetching || !requiresDriverAuthorization
                }
                searchable
                query={query}
                setQuery={setQuery}
              />
            </div>
          </>
        }
      />
    </div>
  );
};
